import { Link } from "react-router-dom";

const Header = (props) => {
  const toggleMenu = () => {
    document
      .querySelector(".navigation__container")
      .classList.toggle("is-open");
  };
  const url = window.location.pathname;

  return (
    <header className="header__container">
      <Link to="/" className="header__logo ff" title="De School" />
      <nav className="navigation__container">
        <Link
          to="/programme"
          className={
            url === "/club"
              ? "navigation__item ff is-active"
              : "navigation__item ff"
          }
          title="Club"
        >
          Programme
        </Link>
        <Link
          to="/cafe"
          className={
            url === "/cafe"
              ? "navigation__item ff is-active"
              : "navigation__item ff"
          }
          title="Café"
        >
          {props.langNL ? "Café" : "Cafe"}
        </Link>
        <Link
          to="/restaurant"
          className={
            url === "/restaurant"
              ? "navigation__item ff is-active"
              : "navigation__item ff"
          }
          title="Restaurant"
        >
          Restaurant
        </Link>

        {/* <Link to="/day" className={url === '/day' ? "navigation__item ff is-active" : "navigation__item ff" } title="Day">Day</Link> */}

        <Link
          to="/art"
          className={
            url === "/art"
              ? "navigation__item ff is-active"
              : "navigation__item ff"
          }
          title="Day"
        >
          Art
        </Link>

        {/*<Link to="/program" className={url === '/program' ? "navigation__item ff is-active" : "navigation__item ff" }>{props.langNL ? 'Programma' : 'Programme'}</Link>*/}
        {/*<Link to="/team" className={url === '/team' ? "navigation__item ff is-active" : "navigation__item ff" }>Team</Link>*/}
        <Link
          to="/jobs"
          className={
            url === "/jobs"
              ? "navigation__item ff is-active"
              : "navigation__item ff"
          }
        >
          Jobs
        </Link>
        <a
          href="https://www.hetgymlokaal.nl/"
          target="_blank"
          rel="noreferrer"
          className="navigation__item ff"
          title="Gym"
        >
          Gym
        </a>

        {/*<Link to="/" className={url === '/' ? "navigation__item ff is-active" : "navigation__item ff" } title="Home">Home</Link>*/}

        {/*<Link to="/tickets" className={url === '/tickets' ? "navigation__item ff is-active" : "navigation__item ff" }>Tickets</Link>*/}

        {/*<a href="https://shop.deschoolamsterdam.nl/" className="navigation__item ff" title="Shop" target="_blank">Shop</a>*/}
        {/*<Link to="/blog" className={url === '/blog' ? "navigation__item ff is-active" : "navigation__item ff" }>Blog</Link>*/}
        {/*<Link to="/contact" className={url === '/contact' ? "navigation__item ff is-active" : "navigation__item ff" }>Contact</Link>*/}
      </nav>
      <div
        className="navigation__trigger js-navigation-trigger ff"
        onClick={toggleMenu}
      >
        Menu
      </div>
      <div className="header__language ff">
        <a
          href="https://www.instagram.com/deschoolamsterdam/"
          target="_blank"
          rel="noreferrer"
          className="header__language-link footer__icon-instagram"
          title=""
        >
          Instagram
        </a>
        {/* <button className={props.langNL ? "header__language--item is-active" : "header__language--item"}
          title="NL"
          onClick={() => {props.changeLang(true); props.resizeGrid()}}>NL</button>
        <span>  &nbsp;  </span>
        <button className={!props.langNL ? "header__language--item is-active" : "header__language--item"}
          title="EN"
          onClick={() => {props.changeLang(false); props.resizeGrid()}}>EN</button> */}
      </div>
    </header>
  );
};

export default Header;
